import { render, staticRenderFns } from "./OCopyrightComp.vue?vue&type=template&id=e5d0f7dc&scoped=true&"
import script from "./OCopyrightComp.vue?vue&type=script&lang=js&"
export * from "./OCopyrightComp.vue?vue&type=script&lang=js&"
import style0 from "./OCopyrightComp.vue?vue&type=style&index=0&id=e5d0f7dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d0f7dc",
  null
  
)

export default component.exports